import { render, staticRenderFns } from "./configure.vue?vue&type=template&id=163575d4&scoped=true"
import script from "./configure.vue?vue&type=script&lang=js"
export * from "./configure.vue?vue&type=script&lang=js"
import style0 from "./configure.vue?vue&type=style&index=0&id=163575d4&prod&lang=scss"
import style1 from "./configure.vue?vue&type=style&index=1&id=163575d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163575d4",
  null
  
)

export default component.exports